/**
 * Máscaras para o campo velocidadeVia (km/h).
 * Bloqueia negativo, letras, separadores e limita a 3 dígitos.
 */

/**
 * Sanitiza valor de velocidade: mantém só dígitos, max 3.
 * @param {*} valor
 * @returns {string}
 */
export function sanitizarVelocidade(valor) {
  if (valor === null || valor === undefined) return "";
  return String(valor).replace(/\D/g, "").slice(0, 3);
}

/**
 * Aplica máscara incremental (para @input).
 * Alias para sanitizarVelocidade, mantido para semântica de masks/.
 * @param {*} valor
 * @returns {string}
 */
export function aplicarMascaraVelocidade(valor) {
  return sanitizarVelocidade(valor);
}

/**
 * Handler para keydown que previne caracteres inválidos (opcional).
 * Bloqueia '-', '+', 'e', 'E', '.', ','.
 * @param {KeyboardEvent} e
 */
export function bloquearTeclasVelocidade(e) {
  if (["-", "+", "e", "E", ".", ","].includes(e.key)) {
    e.preventDefault();
  }
}
